module.exports = __webpack_public_path__ + "img/symbol_5.b2cc53b7.png";